import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import MobileStepper from "@mui/material/MobileStepper";
import Typography from "@mui/material/Typography";

import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

const getItemImageSrc = (item) => item?.imageUrl || "";
const getDisplayEntries = (item) =>
  Object.entries(item || {}).filter(
    ([key, value]) => key !== "imageUrl" && value != null && value !== "",
  );

const AtpCarousel = ({
  items = [],
  showDetails = true,
  showSignup = true,
  rotationSeconds = 5,
  onSignup = null,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [detailsOpen, setDetailsOpen] = useState(false);

  useEffect(() => {
    if (items.length === 0) {
      setActiveIndex(0);
      return;
    }

    if (activeIndex > items.length - 1) {
      setActiveIndex(0);
    }
  }, [items, activeIndex]);

  useEffect(() => {
    if (items.length <= 1 || rotationSeconds <= 0) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % items.length);
    }, (rotationSeconds + 3) * 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [items.length, rotationSeconds]);

  if (items.length === 0) {
    return null;
  }

  const currentItem = items[activeIndex];
  const imageSrc = getItemImageSrc(currentItem);

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % items.length);
  };

  const handleBack = () => {
    setActiveIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  const handleOpenDetails = () => {
    setDetailsOpen(true);
  };

  const handleCloseDetails = () => {
    setDetailsOpen(false);
  };

  const displayEntries = getDisplayEntries(currentItem);

  const handleSignup = () => {
    // Implement signup logic here
    console.log("Signup clicked for item:", currentItem);
    if (onSignup) {
      onSignup(currentItem);
    }
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          mb: 1,
          overflow: "hidden",
          "@keyframes carouselSlideIn": {
            from: {
              opacity: 0,
              transform: "translateX(32px)",
            },
            to: {
              opacity: 1,
              transform: "translateX(0)",
            },
          },
        }}
      >
        <Box
          key={activeIndex}
          sx={{
            animation: "carouselSlideIn 1620ms ease-out",
            willChange: "transform, opacity",
          }}
        >
          {imageSrc !== "" && (
            <CardMedia
              component="img"
              image={imageSrc}
              alt={currentItem.title || "carousel item"}
              onClick={showDetails ? handleOpenDetails : undefined}
              sx={{
                display: "block",
                width: "100%",
                maxWidth: { xs: "100%", md: 760 },
                height: { xs: 180, sm: 240, md: 240 },
                mx: "auto",
                objectFit: { xs: "cover", md: "contain" },
                backgroundColor: { md: "#f7f7f7" },
                cursor: showDetails ? "pointer" : "default",
              }}
            />
          )}
          <CardContent sx={{ pb: 0, textAlign: "center" }}>
            <Typography variant="h6" sx={{ mb: 0.0 }}>
              {currentItem.title || "Item"}
            </Typography>
            {currentItem.detail3 && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {currentItem.detail3}
              </Typography>
            )}
            {showSignup && (
              <Button
                variant="contained"
                size="small"
                onClick={handleSignup}
                sx={{ mx: "auto" }}
              >
                Sign Up
              </Button>
            )}
          </CardContent>
        </Box>

        <MobileStepper
          variant="text"
          steps={items.length}
          position="static"
          activeStep={activeIndex}
          nextButton={
            <IconButton
              size="small"
              onClick={handleNext}
              aria-label="next carousel item"
            >
              <KeyboardArrowRight />
            </IconButton>
          }
          backButton={
            <IconButton
              size="small"
              onClick={handleBack}
              aria-label="previous carousel item"
            >
              <KeyboardArrowLeft />
            </IconButton>
          }
        />
      </Card>

      {showDetails && (
        <Dialog
          open={detailsOpen}
          onClose={handleCloseDetails}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {currentItem.title
              ? currentItem.title
              : "Carousel Details"}
          </DialogTitle>
          <DialogContent>
            {displayEntries.map(([key, value]) => (
              <>
              {key !== "eid" && (
              <Typography key={key} variant="body2" sx={{ mb: 1.5 }}>
                {String(value)}
              </Typography>
              )}
              </>
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDetails}>Close</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default AtpCarousel;
